import React from 'react';
import { BpIntlProvider, BpIntlProviderProps } from '@beeline.com/bp-intl';
import { SUPPORTED_LANGUAGES, SupportedLanguage } from './getLang';

export interface IntlProviderProps extends Omit<BpIntlProviderProps<SupportedLanguage>, 'supportedLanguages'> {}

export const EnterpriseIntlProvider: React.FC<React.PropsWithChildren<IntlProviderProps>> = ({
  children,
  messages,
  getMessages
}) => {
  return (
    <BpIntlProvider messages={messages} supportedLanguages={SUPPORTED_LANGUAGES} getMessages={getMessages}>
      {children}
    </BpIntlProvider>
  );
};
